<template>
  <div
    class="form-group"
    :class="[ divClass ]"
  >
    <slot
      :attrs="{errorMessages: activeErrorMessages, success: isValid}"
      :hasErrors="hasErrors"
    />
  </div>
</template>
<script>
import { singleErrorExtractorMixin } from 'vuelidate-error-extractor'

export default {
  mixins: [singleErrorExtractorMixin],
  props: {
    divClass: String
  }
}
</script>
